// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.search-box {
  flex-shrink: 0;
  padding: 0.5rem;
  background: white;
  border-bottom: 1px solid #e2e8f0;
}

.item-grid-container {
  flex: 1;
  width: 100%;
  position: relative;
  -webkit-user-select: none;
          user-select: none; /* Prevent text selection during drag */
}
.item-grid-container.active {
  background: linear-gradient(to bottom, rgba(102, 126, 234, 0.03), transparent);
}
.item-grid-container.selecting {
  cursor: crosshair;
}
.item-grid-container.drag-over {
  background: rgba(102, 126, 234, 0.1);
  border: 2px dashed #667eea;
}
.item-grid-container.drag-over::after {
  content: "Drop items here";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.2rem;
  font-weight: 600;
  color: #667eea;
  background: white;
  padding: 1rem 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  pointer-events: none;
  z-index: 10;
}
.item-grid-container .item-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 0.5rem;
  padding: 0.75rem;
  align-content: start;
}
.item-grid-container .item-grid .item-card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
}
.item-grid-container .item-grid .item-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.2);
  border-color: rgba(102, 126, 234, 0.5);
}
.item-grid-container .item-grid .item-card:hover .item-card-content h3 {
  color: #667eea;
}
.item-grid-container .item-grid .item-card.marked {
  border-color: #f39c12;
  box-shadow: 0 4px 12px rgba(243, 156, 18, 0.3);
  background: #fffbf5;
}
.item-grid-container .item-grid .item-card.marked .item-card-image {
  border-bottom: 3px solid #f39c12;
}
.item-grid-container .item-grid .item-card.marked:hover {
  box-shadow: 0 6px 16px rgba(243, 156, 18, 0.4);
}
.item-grid-container .item-grid .item-card.dragging {
  opacity: 0.5;
  transform: scale(0.95);
}
.item-grid-container .item-grid .item-card .item-card-image {
  position: relative;
  width: 100%;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.item-grid-container .item-grid .item-card .item-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.item-grid-container .item-grid .item-card .item-card-image .placeholder-icon {
  font-size: 2rem;
  color: white;
  opacity: 0.6;
}
.item-grid-container .item-grid .item-card .item-card-image .mark-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #f39c12;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.item-grid-container .item-grid .item-card .item-card-image .mark-indicator ion-icon {
  font-size: 1.2rem;
  color: white;
}
.item-grid-container .item-grid .item-card .item-card-content {
  padding: 0.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.item-grid-container .item-grid .item-card .item-card-content h3 {
  font-weight: 600;
  font-size: 0.75rem;
  margin: 0 0 0.25rem 0;
  color: #2d3748;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.2;
}
.item-grid-container .item-grid .item-card .item-card-content .item-code {
  font-size: 0.7rem;
  color: #718096;
  margin: 0 0 0.25rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-grid-container .item-grid .item-card .item-card-content .section-badge {
  font-size: 0.65rem;
  color: #667eea;
  font-weight: 600;
  background: rgba(102, 126, 234, 0.1);
  padding: 0.15rem 0.35rem;
  border-radius: 8px;
  display: inline-block;
  align-self: flex-start;
}
.item-grid-container .item-grid .item-card .item-card-content .section-badge.section-names {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: rgba(46, 213, 115, 0.1);
  color: #2ed573;
}
.item-grid-container .item-grid .item-card .item-card-content .edit-input {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #667eea;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  outline: none;
  transition: all 0.2s;
}
.item-grid-container .item-grid .item-card .item-card-content .edit-input:focus {
  border-color: #764ba2;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.item-grid-container .item-grid .item-card .item-card-actions {
  padding: 0.35rem;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(102, 126, 234, 0.1);
}
.item-grid-container .item-grid .item-card .item-card-actions ion-icon {
  font-size: 1rem;
  color: #667eea;
  opacity: 0.6;
  transition: all 0.2s;
  cursor: pointer;
}
.item-grid-container .item-grid .item-card .item-card-actions ion-icon:hover {
  opacity: 1;
  transform: scale(1.15);
}
.item-grid-container .selection-rectangle {
  position: absolute;
  border: 2px solid #667eea;
  background: rgba(102, 126, 234, 0.15);
  pointer-events: none;
  z-index: 1000;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(102, 126, 234, 0.3);
}
.item-grid-container .empty-state {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 3rem 2rem;
  width: 100%;
  max-width: 400px;
}
.item-grid-container .empty-state .empty-state-content {
  background: white;
  border-radius: 16px;
  padding: 3rem 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 2px dashed #e2e8f0;
}
.item-grid-container .empty-state .empty-state-content ion-icon {
  font-size: 5rem;
  color: #cbd5e0;
  margin-bottom: 1.5rem;
  animation: pulse 2s ease-in-out infinite;
}
.item-grid-container .empty-state .empty-state-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 0.75rem 0;
}
.item-grid-container .empty-state .empty-state-content p {
  font-size: 1rem;
  color: #718096;
  margin: 0 0 1.5rem 0;
  line-height: 1.5;
}
.item-grid-container .empty-state .empty-state-content .empty-state-action {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}
.item-grid-container .empty-state .empty-state-content .empty-state-action ion-icon {
  font-size: 1.2rem;
  color: white;
  margin: 0;
  animation: none;
}
.item-grid-container .empty-state .empty-state-content .empty-state-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}
.item-grid-container .empty-state .empty-state-content .empty-state-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background: #f7fafc;
  border-radius: 8px;
  color: #4a5568;
  font-size: 0.9rem;
}
.item-grid-container .empty-state .empty-state-content .empty-state-hint ion-icon {
  font-size: 1.2rem;
  color: #667eea;
  margin: 0;
  animation: none;
}

.pagination-container {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: white;
  border-top: 1px solid #e2e8f0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}
.pagination-container .pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 2px solid #667eea;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  color: #667eea;
}
.pagination-container .pagination-btn ion-icon {
  font-size: 1.2rem;
  pointer-events: none;
}
.pagination-container .pagination-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.pagination-container .pagination-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  border-color: #cbd5e0;
  color: #cbd5e0;
}
.pagination-container .pagination-info {
  font-size: 0.95rem;
  font-weight: 600;
  color: #2d3748;
  min-width: 120px;
  text-align: center;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}
@media (max-width: 1600px) {
  .item-grid-container .item-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 1200px) {
  .item-grid-container .item-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 768px) {
  .item-grid-container .item-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    padding: 0.75rem;
  }
}
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.dialog-container {
  background: white;
  border-radius: 12px;
  padding: 0;
  min-width: 400px;
  max-width: 500px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.dialog-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}
.dialog-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
}

.dialog-content {
  padding: 24px;
}
.dialog-content p {
  margin: 0;
  font-size: 1rem;
  color: #666;
  line-height: 1.5;
}

.dialog-actions {
  padding: 16px 24px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}
.btn ion-icon {
  font-size: 1.2rem;
}
.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.btn:active {
  transform: translateY(0);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
.btn-primary:hover {
  background: linear-gradient(135deg, #5568d3 0%, #63408a 100%);
}

.btn-secondary {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}
.btn-secondary:hover {
  background: linear-gradient(135deg, #d97fe0 0%, #d94858 100%);
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
}
.btn-cancel:hover {
  background: #e0e0e0;
}

@media (max-width: 480px) {
  .item-grid-container .item-grid {
    grid-template-columns: 1fr;
  }
  .dialog-container {
    min-width: 90%;
    max-width: 90%;
  }
  .dialog-actions {
    flex-direction: column;
  }
  .dialog-actions .btn {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/catalog-manager/item-list/item-list.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AACF;;AAEA;EACE,OAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA,EAAA,uCAAA;AACF;AACE;EACE,8EAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AAGE;EACE,oCAAA;EACA,0BAAA;AADJ;AAGI;EACE,0BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,oBAAA;EACA,WAAA;AADN;AAKE;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAHJ;AAKI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,yCAAA;EACA,6BAAA;AAHN;AAKM;EACE,2BAAA;EACA,+CAAA;EACA,sCAAA;AAHR;AAKQ;EACE,cAAA;AAHV;AAOM;EACE,qBAAA;EACA,8CAAA;EACA,mBAAA;AALR;AAOQ;EACE,gCAAA;AALV;AAQQ;EACE,8CAAA;AANV;AAUM;EACE,YAAA;EACA,sBAAA;AARR;AAWM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AATR;AAWQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AATV;AAYQ;EACE,eAAA;EACA,YAAA;EACA,YAAA;AAVV;AAaQ;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;AAXV;AAaU;EACE,iBAAA;EACA,YAAA;AAXZ;AAgBM;EACE,eAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AAdR;AAgBQ;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAdV;AAiBQ;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAfV;AAkBQ;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AAhBV;AAkBU;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;AAhBZ;AAoBQ;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;AAlBV;AAoBU;EACE,qBAAA;EACA,8CAAA;AAlBZ;AAuBM;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,8CAAA;AArBR;AAuBQ;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AArBV;AAuBU;EACE,UAAA;EACA,sBAAA;AArBZ;AA6BE;EACE,kBAAA;EACA,yBAAA;EACA,qCAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,6CAAA;AA3BJ;AA+BE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AA7BJ;AA+BI;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,0BAAA;AA7BN;AA+BM;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,wCAAA;AA7BR;AAgCM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AA9BR;AAiCM;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;AA/BR;AAkCM;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAhCR;AAkCQ;EACE,iBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;AAhCV;AAmCQ;EACE,2BAAA;EACA,+CAAA;AAjCV;AAqCM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAnCR;AAqCQ;EACE,iBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;AAnCV;;AA2CA;EACE,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,2CAAA;AAxCF;AA0CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAxCJ;AA0CI;EACE,iBAAA;EACA,oBAAA;AAxCN;AA2CI;EACE,6DAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;AAzCN;AA4CI;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AA1CN;AA8CE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA5CJ;;AAgDA;EACE;IACE,YAAA;IACA,mBAAA;EA7CF;EA+CA;IACE,YAAA;IACA,sBAAA;EA7CF;AACF;AAiDA;EACE;IACE,qCAAA;EA/CF;AACF;AAkDA;EACE;IACE,qCAAA;EAhDF;AACF;AAmDA;EACE;IACE,qCAAA;IACA,YAAA;IACA,gBAAA;EAjDF;AACF;AAqDA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAnDF;;AAsDA;EACE,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gCAAA;AAnDF;;AAsDA;EACE;IACE,4BAAA;IACA,UAAA;EAnDF;EAqDA;IACE,wBAAA;IACA,UAAA;EAnDF;AACF;AAsDA;EACE,kBAAA;EACA,gCAAA;AApDF;AAsDE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AApDJ;;AAwDA;EACE,aAAA;AArDF;AAuDE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AArDJ;;AAyDA;EACE,uBAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AAtDF;;AAyDA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AAtDF;AAwDE;EACE,iBAAA;AAtDJ;AAyDE;EACE,2BAAA;EACA,0CAAA;AAvDJ;AA0DE;EACE,wBAAA;AAxDJ;;AA4DA;EACE,6DAAA;EACA,YAAA;AAzDF;AA2DE;EACE,6DAAA;AAzDJ;;AA6DA;EACE,6DAAA;EACA,YAAA;AA1DF;AA4DE;EACE,6DAAA;AA1DJ;;AA8DA;EACE,mBAAA;EACA,WAAA;AA3DF;AA6DE;EACE,mBAAA;AA3DJ;;AA+DA;EACE;IACE,0BAAA;EA5DF;EA+DA;IACE,cAAA;IACA,cAAA;EA7DF;EAgEA;IACE,sBAAA;EA9DF;EAgEE;IACE,WAAA;IACA,uBAAA;EA9DJ;AACF","sourcesContent":[".item-list-wrapper {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.search-box {\n  flex-shrink: 0;\n  padding: 0.5rem;\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.item-grid-container {\n  flex: 1;\n  width: 100%;\n  position: relative;\n  user-select: none; /* Prevent text selection during drag */\n\n  &.active {\n    background: linear-gradient(to bottom, rgba(102, 126, 234, 0.03), transparent);\n  }\n\n  &.selecting {\n    cursor: crosshair;\n  }\n\n  &.drag-over {\n    background: rgba(102, 126, 234, 0.1);\n    border: 2px dashed #667eea;\n    \n    &::after {\n      content: 'Drop items here';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      font-size: 1.2rem;\n      font-weight: 600;\n      color: #667eea;\n      background: white;\n      padding: 1rem 2rem;\n      border-radius: 12px;\n      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n      pointer-events: none;\n      z-index: 10;\n    }\n  }\n\n  .item-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n    gap: 0.5rem;\n    padding: 0.75rem;\n    align-content: start;\n\n    .item-card {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      background: white;\n      border-radius: 8px;\n      overflow: hidden;\n      cursor: pointer;\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n      border: 2px solid transparent;\n\n      &:hover {\n        transform: translateY(-4px);\n        box-shadow: 0 6px 16px rgba(102, 126, 234, 0.2);\n        border-color: rgba(102, 126, 234, 0.5);\n        \n        .item-card-content h3 {\n          color: #667eea;\n        }\n      }\n\n      &.marked {\n        border-color: #f39c12;\n        box-shadow: 0 4px 12px rgba(243, 156, 18, 0.3);\n        background: #fffbf5;\n        \n        .item-card-image {\n          border-bottom: 3px solid #f39c12;\n        }\n        \n        &:hover {\n          box-shadow: 0 6px 16px rgba(243, 156, 18, 0.4);\n        }\n      }\n\n      &.dragging {\n        opacity: 0.5;\n        transform: scale(0.95);\n      }\n\n      .item-card-image {\n        position: relative;\n        width: 100%;\n        height: 80px;\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n\n        .placeholder-icon {\n          font-size: 2rem;\n          color: white;\n          opacity: 0.6;\n        }\n\n        .mark-indicator {\n          position: absolute;\n          top: 4px;\n          right: 4px;\n          background: #f39c12;\n          border-radius: 50%;\n          width: 24px;\n          height: 24px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n\n          ion-icon {\n            font-size: 1.2rem;\n            color: white;\n          }\n        }\n      }\n\n      .item-card-content {\n        padding: 0.5rem;\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n\n        h3 {\n          font-weight: 600;\n          font-size: 0.75rem;\n          margin: 0 0 0.25rem 0;\n          color: #2d3748;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          line-height: 1.2;\n        }\n\n        .item-code {\n          font-size: 0.7rem;\n          color: #718096;\n          margin: 0 0 0.25rem 0;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        .section-badge {\n          font-size: 0.65rem;\n          color: #667eea;\n          font-weight: 600;\n          background: rgba(102, 126, 234, 0.1);\n          padding: 0.15rem 0.35rem;\n          border-radius: 8px;\n          display: inline-block;\n          align-self: flex-start;\n\n          &.section-names {\n            max-width: 100%;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            background: rgba(46, 213, 115, 0.1);\n            color: #2ed573;\n          }\n        }\n\n        .edit-input {\n          width: 100%;\n          padding: 0.5rem;\n          border: 2px solid #667eea;\n          border-radius: 6px;\n          font-size: 0.9rem;\n          font-weight: 500;\n          outline: none;\n          transition: all 0.2s;\n\n          &:focus {\n            border-color: #764ba2;\n            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n          }\n        }\n      }\n\n      .item-card-actions {\n        padding: 0.35rem;\n        display: flex;\n        justify-content: flex-end;\n        border-top: 1px solid rgba(102, 126, 234, 0.1);\n\n        ion-icon {\n          font-size: 1rem;\n          color: #667eea;\n          opacity: 0.6;\n          transition: all 0.2s;\n          cursor: pointer;\n\n          &:hover {\n            opacity: 1;\n            transform: scale(1.15);\n          }\n        }\n      }\n    }\n  }\n\n  // Selection rectangle styling\n  .selection-rectangle {\n    position: absolute;\n    border: 2px solid #667eea;\n    background: rgba(102, 126, 234, 0.15);\n    pointer-events: none;\n    z-index: 1000;\n    border-radius: 4px;\n    box-shadow: 0 0 10px rgba(102, 126, 234, 0.3);\n  }\n\n  // Empty state styling\n  .empty-state {\n    position: absolute;\n    top: 30%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    padding: 3rem 2rem;\n    width: 100%;\n    max-width: 400px;\n\n    .empty-state-content {\n      background: white;\n      border-radius: 16px;\n      padding: 3rem 2rem;\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n      border: 2px dashed #e2e8f0;\n\n      ion-icon {\n        font-size: 5rem;\n        color: #cbd5e0;\n        margin-bottom: 1.5rem;\n        animation: pulse 2s ease-in-out infinite;\n      }\n\n      h3 {\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: #2d3748;\n        margin: 0 0 0.75rem 0;\n      }\n\n      p {\n        font-size: 1rem;\n        color: #718096;\n        margin: 0 0 1.5rem 0;\n        line-height: 1.5;\n      }\n\n      .empty-state-action {\n        display: inline-flex;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.75rem 1.5rem;\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        color: white;\n        border: none;\n        border-radius: 8px;\n        font-size: 0.95rem;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.3s;\n\n        ion-icon {\n          font-size: 1.2rem;\n          color: white;\n          margin: 0;\n          animation: none;\n        }\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);\n        }\n      }\n\n      .empty-state-hint {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        margin-top: 1rem;\n        padding: 0.75rem 1rem;\n        background: #f7fafc;\n        border-radius: 8px;\n        color: #4a5568;\n        font-size: 0.9rem;\n\n        ion-icon {\n          font-size: 1.2rem;\n          color: #667eea;\n          margin: 0;\n          animation: none;\n        }\n      }\n    }\n  }\n}\n\n// Pagination styling\n.pagination-container {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: white;\n  border-top: 1px solid #e2e8f0;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);\n\n  .pagination-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border: 2px solid #667eea;\n    background: white;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s;\n    color: #667eea;\n\n    ion-icon {\n      font-size: 1.2rem;\n      pointer-events: none;\n    }\n\n    &:hover:not(:disabled) {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: white;\n      transform: translateY(-2px);\n      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n    }\n\n    &:disabled {\n      opacity: 0.3;\n      cursor: not-allowed;\n      border-color: #cbd5e0;\n      color: #cbd5e0;\n    }\n  }\n\n  .pagination-info {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #2d3748;\n    min-width: 120px;\n    text-align: center;\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 0.6;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.05);\n  }\n}\n\n// Responsive grid\n@media (max-width: 1600px) {\n  .item-grid-container .item-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 1200px) {\n  .item-grid-container .item-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .item-grid-container .item-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n    padding: 0.75rem;\n  }\n}\n\n// Move/Copy Dialog Styles\n.dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n}\n\n.dialog-container {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  min-width: 400px;\n  max-width: 500px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.2s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.dialog-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  \n  h3 {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #333;\n  }\n}\n\n.dialog-content {\n  padding: 24px;\n  \n  p {\n    margin: 0;\n    font-size: 1rem;\n    color: #666;\n    line-height: 1.5;\n  }\n}\n\n.dialog-actions {\n  padding: 16px 24px 24px;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s;\n  \n  ion-icon {\n    font-size: 1.2rem;\n  }\n  \n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  \n  &:hover {\n    background: linear-gradient(135deg, #5568d3 0%, #63408a 100%);\n  }\n}\n\n.btn-secondary {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n  \n  &:hover {\n    background: linear-gradient(135deg, #d97fe0 0%, #d94858 100%);\n  }\n}\n\n.btn-cancel {\n  background: #f5f5f5;\n  color: #666;\n  \n  &:hover {\n    background: #e0e0e0;\n  }\n}\n\n@media (max-width: 480px) {\n  .item-grid-container .item-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .dialog-container {\n    min-width: 90%;\n    max-width: 90%;\n  }\n  \n  .dialog-actions {\n    flex-direction: column;\n    \n    .btn {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
